var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n:-ms-input-placeholder{\n  color: white;\n}\n::placeholder{\n  color: white;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _globals = require('../mixins/globals');

var _globals2 = _interopRequireDefault(_globals);

var _UiAlert = require('../material/UiAlert.vue');

var _UiAlert2 = _interopRequireDefault(_UiAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SignIn',
  mixins: [_globals2.default],
  components: {
    UiAlert: _UiAlert2.default
  },
  data: function data() {
    return {
      viewForm: false,
      loadLogin: false,
      login: {
        usuario: '',
        password: ''
      },
      error: {
        status: false,
        message: 'Vuelva a ingresar sus datos'
      },
      flagForgot: false,
      forgotEmail: '',
      disabledForgot: false,
      loadingForgot: false,
      errorForgot: {
        status: false,
        message: 'No hay registro de algun usuario correspondiente a este correo o el usuario puede haber sido eliminado.'
      },
      successForgot: {
        status: false,
        message: 'Se envio correctamente un mensaje a su correo.'
      }
    };
  },

  watch: {
    forgotEmail: function forgotEmail(val, old) {
      if (this.validateEmail(val)) {
        this.disabledForgot = true;
      } else {
        this.disabledForgot = false;
      }
    },
    'errorForgot.status': function errorForgotStatus(val, oldval) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          _this.errorForgot.status = false;
          _this.successForgot.status = false;
        }, 1600);
      }
    },
    'successForgot.status': function successForgotStatus(val, oldval) {
      var _this2 = this;

      if (val) {
        setTimeout(function () {
          _this2.successForgot.status = false;
          _this2.errorForgot.status = false;
          _this2.flagForgot = false;
        }, 1600);
      }
    }
  },
  methods: {
    onSubmitLogin: function onSubmitLogin() {
      var _this3 = this;

      this.loadLogin = true;
      var url = '/login';

      var data = {
        username: this.login.usuario,
        password: this.login.password
      };

      this.$http.post(url, data).then(function (response) {
        var _data = response.data;
        _this3.error.status = false;
        _this3.loadLogin = false;

        var userRole = void 0;
        if (_data.local_id == 0) {
          if (_data.restaurante_id == 0) {
            userRole = 'admin';
          } else {
            userRole = 'gerente';
          }
        } else {
          userRole = 'subgerente';
        }
        window.localStorage.setItem('restaurante', _data.restaurante_id);
        window.localStorage.setItem('local', _data.local_id);
        window.localStorage.setItem('role', userRole);
        window.localStorage.setItem('uid', _data.id);
        _this3.$router.go({
          name: 'usuarios-lista'
        });
      }, function (response) {
        _this3.error.status = true;
        _this3.loadLogin = false;
      });
    },
    validateEmail: function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    onSubmitForgot: function onSubmitForgot() {
      var _this4 = this;

      this.loadingForgot = true;
      var url = '/forgot';
      var data = {
        email: this.forgotEmail
      };
      this.$http.post(url, data).then(function (success) {
        _this4.errorForgot.status = false;
        _this4.loadingForgot = false;
        _this4.forgotEmail = '';
        _this4.successForgot.status = true;
      }, function (error) {
        _this4.successForgot.status = false;
        _this4.loadingForgot = false;
        _this4.forgotEmail = '';
        _this4.errorForgot.status = true;
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"bg-log\"></div>\n<div class=\"login-table\">\n  <div class=\"login-cell\">\n    <div class=\"login-container\">\n      <div class=\"login-header\">\n        <img src=\"/assets/img/logo_civitano.png\" alt=\"logo\">\n      </div>\n      <div class=\"login-body\">\n        <template v-if=\"!flagForgot\">\n          <div class=\"clearfix sign\">\n            <ui-alert :show=\"error.status\" type=\"error\" :dismissible=\"false\">\n              <span>{{ error.message }}</span>\n            </ui-alert>\n            <ui-textbox @keyup.enter=\"onSubmitLogin()\" name=\"usuario\" type=\"text\" placeholder=\"Usuario\" :value.sync=\"login.usuario\" hide-label=\"\" autocomplete=\"off\" icon=\"mail_outline\"></ui-textbox>\n\n            <ui-textbox @keyup.enter=\"onSubmitLogin()\" name=\"password\" type=\"password\" placeholder=\"Contraseña\" :value.sync=\"login.password\" hide-label=\"\" autocomplete=\"off\" icon=\"lock_open\"></ui-textbox>\n\n            <ui-button color=\"lanacional-cuarto\" text=\"Login\" @click=\"onSubmitLogin()\" :loading=\"loadLogin\"></ui-button>\n            <div class=\"text_sign\">\n              <button type=\"button\" class=\"btn btn-register\" @click=\"flagForgot = !flagForgot\">Olvidó su contraseña</button>\n            </div>\n          </div>\n        </template>\n        <template v-else=\"\">\n          <ui-alert type=\"error\" :show=\"errorForgot.status\" :dismissible=\"false\">{{errorForgot.message}}</ui-alert>\n          <ui-alert type=\"success\" :show=\"successForgot.status\" :dismissible=\"false\">{{successForgot.message}}</ui-alert>\n          <ui-textbox @keyup.enter=\"onSubmitForgot()\" name=\"email\" type=\"email\" placeholder=\"Correo\" :value.sync=\"forgotEmail\" hide-label=\"\" autocomplete=\"off\" icon=\"mail_outline\"></ui-textbox>\n          <ui-button text=\"Enviar\" @click=\"onSubmitForgot()\" :loading=\"loadingForgot\" color=\"lanacional-cuarto\" :disabled=\"!disabledForgot\"></ui-button>\n          <div class=\"text_sign\">\n            <button type=\"button\" class=\"btn btn-register\" @click=\"flagForgot = !flagForgot\">Atras</button>\n          </div>\n        </template>\n      </div>\n    </div>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n:-ms-input-placeholder{\n  color: white;\n}\n::placeholder{\n  color: white;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-12c40fb9", module.exports)
  } else {
    hotAPI.update("_v-12c40fb9", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}